export default __webpack_public_path__ + "static/media/shiroishi.96a6e1e1.png";